/**
 * Duplicate adherence post button for Protocol Management
 */
(function( $ ) {
	'use strict';

	//fire funcs when ready
	ready( duplicateAdhPostEvent );

	/**
	 * Detect if doc is ready and fire func inside
	 *
	 * @param fn
	 */
	function ready( fn ) {
		if ( document.attachEvent
				? document.readyState === 'complete'
				: document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	}

	/**
	 * Click event for duplicating adherence post
	 */
	function duplicateAdhPostEvent() {
		var duplicateAdhBtns = document.querySelectorAll( '.btn-duplicate-adh-letter' ), i;

		if ( duplicateAdhBtns === null ) {
			return;
		}

		for ( i = 0; i < duplicateAdhBtns.length; ++i ) {
			duplicateAdhBtns[ i ].addEventListener( 'click', function( e ) {
				e.preventDefault();
				passAdhIdFromDuplicateBtn( e, this.getAttribute( 'data-duplicate' ), this.getAttribute( 'data-form' ) );
			} );
		}
	}

	/**
	 * Function to pass adherence ID to endpoint that will redirect to form
	 *
	 * @param $adhId
	 */
	function passAdhIdFromDuplicateBtn( e, $adhId, $formUrl ) {
		$.ajax( {
			        type   : 'POST',
			        url    : wpApiSettings.root + 'isda/v1/duplicate-adh-post',
			        data   : {
				        adherence_id: $adhId,
				        form_url: $formUrl
			        },
			        success: function( data ) {
				        console.log( data );
				        window.location = data.form_url + '?duplicate=' + data.adherence_id;
			        }
		        } );
	}

}
)( jQuery );